<template>
	<div>
		<div v-if="!canEdit">
			<p>
				<FormTitleText :titleText="$t('profile.teamsEmail')" />
			</p>
			{{ value ? value : '-' }}
		</div>
		<validationProvider
			v-else
			:rules="{ required: true, regex: teamsEmailRegex }"
			v-slot="{ errors, valid }"
			name="Teamsメールアドレス"
			immediate
		>
			<p>
				<FormTitleText :titleText="$t('profile.teamsEmail')" />
				<FormAttentionText :attentionText="$t('profile.onlyHalfWidthAndNum')" />
			</p>
			<v-text-field
				label="teamsEmail"
				v-model="inputtedTeamsEmail"
				outlined
				background-color="white"
				hide-details
				:success="valid"
			></v-text-field>
			<FormErrorText :errorText="errors[0]" />
		</validationProvider>
	</div>
</template>

<script>
import FormTitleText from '../Atoms/FormTitleText'
import FormErrorText from '../Atoms/FormErrorText'
import FormAttentionText from '../Atoms/FormAttentionText'

export default {
	name: 'TeamsEmailForm',
	data: () => ({
		teamsEmailRegex: /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/
	}),
	props: {
		value: {
			type: String,
			required: true
		},
		canEdit: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	mounted() {},
	computed: {
		inputtedTeamsEmail: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {},
	components: {
		FormTitleText,
		FormErrorText,
		FormAttentionText
	}
}
</script>

<style lang="scss" scoped></style>
